﻿
<div class="localizar-visto-layout">
    <aside class="coluna-filtros">
        <app-card-content [icon]="'pi pi-search'" [title]="'Pesquisa'" [subtitle]="'Médicos com Visto Temporário'">
            <form [formGroup]="filtroForm" class="card-filtros-body">
                <div class="filtros-linha">
                    <div class="field">
                        <label class="block mb-1">Tipo do visto</label>
                        <p-select [appendTo]="'body'" class="w-full" formControlName="tipo" [options]="tipos" optionLabel="label" optionValue="value"></p-select>
                    </div>

                    <div class="field">
                        <label class="block mb-1">Solicitação de Visto</label>
                        <p-select [appendTo]="'body'" class="w-full" formControlName="solicitacaoVisto" [options]="solicitacoesVisto" optionLabel="label" optionValue="value"></p-select>
                    </div>
                </div>

                <div class="filtros-linha">
                    <div class="field">
                        <label class="block mb-1">Nº Protocolo</label>
                        <input pInputText formControlName="numeroProtocolo" class="w-full" />
                    </div>

                    <div class="field">
                        <label class="block mb-1">Ano</label>
                        <input pInputText formControlName="ano" class="w-full" />
                    </div>
                </div>

                <div class="field">
                    <label class="block mb-1">Solicitante visto provisório</label>
                    <input pInputText formControlName="solicitanteVistoTemporario" class="w-full" />
                </div>

                <div class="acoes-filtro">
                    <p-button label="Pesquisar" icon="pi pi-search" [loading]="pesquisando()" [disabled]="pesquisando()" (onClick)="onPesquisar()"></p-button>
                </div>
            </form>
        </app-card-content>

        @if (pesquisou) {
            <app-card-content class="card-protocolos" [headerColor]="false" [icon]="'pi pi-list'" [title]="'Protocolos encontrados'">
                @if (!protocolos.length) {
                    <div class="lista-vazia"><i>Nenhum protocolo encontrado.</i></div>
                } @else {
                    <div class="protocolos-lista">
                        @for (item of protocolos; track item.idProtocolo ?? item.numeroProtocolo + '-' + item.anoProtocolo) {
                            <button
                                type="button"
                                class="protocolo-card"
                                [class.selecionada]="isProtocoloSelecionado(item)"
                                (click)="onSelecionarProtocolo(item)"
                                (keydown.enter)="onSelecionarProtocolo(item)"
                                (keydown.space)="onSelecionarProtocolo(item); $event.preventDefault()"
                            >
                                <span class="protocolo-card-label">Protocolo</span>
                                <strong>{{ item.numeroProtocolo }}/{{ item.anoProtocolo }}</strong>
                            </button>
                        }
                    </div>
                }
            </app-card-content>
        }
    </aside>

    <section class="coluna-conteudo">
        @if (erroPesquisa) {
            <app-card-content class="erro-pesquisa-card" [headerColor]="false" [icon]="'pi pi-exclamation-triangle'" [title]="'Erro na pesquisa'">
                <div class="erro-pesquisa-texto">{{ erroPesquisa }}</div>
            </app-card-content>
        }

        @if (pesquisou && protocolos.length > 0) {
            <div class="localizar-visto-conteudo">
                <app-card-content class="card-resultado" [icon]="'pi pi-info-circle'" [title]="'Informações sobre o protocolo selecionado'">
                    <div class="localizar-visto-painel">
                        @if (carregandoSolicitantes()) {
                            <div class="status-protocolo">Carregando solicitantes do protocolo...</div>
                        }
                        @if (erroSelecaoProtocolo) {
                            <div class="erro-protocolo">{{ erroSelecaoProtocolo }}</div>
                        }
                        @if (!protocoloSelecionadoId && !carregandoSolicitantes() && !erroSelecaoProtocolo) {
                            <div class="status-protocolo">Selecione um protocolo para visualizar os solicitantes.</div>
                        }

                        <div class="info-section">
                            <div class="info-section-title">
                                <i class="pi pi-user" aria-hidden="true"></i>
                                <span>Solicitante / Interessado</span>
                            </div>
                            @if (!solicitantes.length) {
                                <div class="lista-vazia"><i>Nenhum solicitante.</i></div>
                            } @else {
                                <div class="solicitantes-lista">
                                    @for (item of solicitantes; track item.uf + '-' + item.solicitante) {
                                        <article class="solicitante-card">
                                            <app-pessoa-avatar [idSolicitante]="item.idSolicitante" [uf]="item.uf" [nome]="item.solicitante" tamanho="lg" [clicavel]="true" (fotoSelecionada)="ampliarFoto($event)" />
                                            <div class="solicitante-info">
                                                <strong>{{ item.solicitante }}</strong>
                                                <span class="uf-pill">{{ item.uf || '-' }}</span>
                                            </div>
                                        </article>
                                    }
                                </div>
                            }
                        </div>

                        <div class="info-section">
                            <div class="info-section-title">
                                <i class="pi pi-tags" aria-hidden="true"></i>
                                <span>Assuntos</span>
                            </div>
                            @if (!assuntos.length) {
                                <div class="lista-vazia"><i>Nenhum assunto.</i></div>
                            } @else {
                                <div class="assuntos-lista">
                                    @for (item of assuntos; track item.assunto) {
                                        <span class="assunto-pill">{{ item.assunto }}</span>
                                    }
                                </div>
                            }
                        </div>

                        <form [formGroup]="protocoloForm">
                            <div class="info-section">
                                <div class="info-section-title">
                                    <i class="pi pi-align-left" aria-hidden="true"></i>
                                    <span>Finalidade</span>
                                </div>
                                <textarea pTextarea rows="5" formControlName="finalidade" class="w-full"></textarea>
                            </div>
                        </form>
                    </div>

                    <div class="localizar-visto-acoes localizar-visto-acoes--card">
                        <!--                        <p-button label="Cancelar" icon="pi pi-times" [text]="true" (onClick)="onCancelar()"></p-button>-->
                        <p-button label="Confirmar" icon="pi pi-check" (onClick)="onConfirmar()"></p-button>
                    </div>
                </app-card-content>
            </div>
        } @else {
            <app-card-content [icon]="'pi pi-search'" [title]="'Localizar visto temporário'">
                <div class="sem-dados">
                    @if (pesquisou && protocolos.length === 0 && !erroPesquisa) {
                        <strong>Não houve visto encontrado com os parâmetros informados.</strong>
                    } @else {
                        Preencha os filtros e clique em Pesquisar para visualizar os dados do visto temporário.
                    }
                </div>
            </app-card-content>
        }
    </section>
</div>

<!-- Foto ampliada do solicitante (mesmo padrão de zoom da Capa de PAT/Dívida Ativa). -->
<p-dialog appDialogoPadrao="pi pi-image" descricao="Foto do cadastro, em tamanho ampliado." [(visible)]="fotoAmpliadaVisivel" [style]="{ width: 'fit-content' }" header="Visualização da Foto" [dismissableMask]="true">
    @if (fotoAmpliada(); as foto) {
        <div class="flex items-center justify-center p-2">
            <img [src]="foto" alt="Foto ampliada" style="width: 300px; height: 300px; object-fit: cover; border-radius: 8px" />
        </div>
    }
</p-dialog>
